import {
  FAST_INSTRUMENT_BASE_URL,
  FORMULATRIX_LABWARE_BASE_URL,
  FAST_LIQUID_HANDLER_BASE_URL,
} from 'constants/appConstant';
import {invokeAPI} from './commonBusiness';
import {setConfig} from '../actions/configStateAction';

import {SignalRHub, SignalREvent} from '../../constants/dataEnum';
import {getWebserverConfigPromise} from '../../lib/webserverConfigHelper';

export const getDeviceConfig = () => (dispatch, getState) => {
  getWebserverConfigPromise()
    .then((response) => {
      const {configState} = getState();
      console.log('getDeviceConfig response:', response);
      dispatch(setConfig({...configState, ...response.data}));
    })
    .catch((error) => {
      console.log('getDeviceConfig error:', error);
    });
};

// #region get config
export function getConfig() {
  return async (dispatch, getState) => {
    console.log('getConfig');
    const {configState} = getState();
    const response = await dispatch(invokeAPI(SignalRHub.AUTHORING, SignalREvent.GET_CONFIG));
    console.log('getConfig response:', response);

    const urlInstrumentControlLocation = response?.instrumentConfig?.instrumentURL
      ? `${window.location.protocol}//${response.instrumentConfig.instrumentURL}`
      : FAST_INSTRUMENT_BASE_URL;
    const urlLabwareDefinitionRepository = response?.instrumentConfig?.labwareDefinitionRepositoryURL
      ? `${window.location.protocol}//${response.instrumentConfig.labwareDefinitionRepositoryURL}`
      : FORMULATRIX_LABWARE_BASE_URL;

    const {isActive: isSmartTipPositionActive, smartTipLists} = response.smartTipConfig;

    dispatch(
      setConfig({
        ...configState,
        ...response.serialDilutionDefaultParameters,
        ...response.liquidTransferConfig,
        smartTipLists,
        isSmartTipPositionActive,
        version: response.softwareVersion,
        hubHost: {
          urlAuthoringLocation: FAST_LIQUID_HANDLER_BASE_URL,
          urlLabwareDefinitionRepository,
          urlInstrumentControlLocation,
        },
      }),
    );
  };
}
// #endregion get config
